(function () {
  'use strict';

  angular.module('app').service('CreditNoteModalService', CreditNoteModalService);

  CreditNoteModalService.$inject = ['ModalService'];

  function CreditNoteModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openSendCreditNoteToClient: openSendCreditNoteToClient,
    };

    return service;

    ////////////////////////

    // Modal invoice send email
    function openSendCreditNoteToClient(clientEmail, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/credit-notes/modals/send-credit-note-to-client-modal.html',
        controller: SendCreditNoteToClientCtrl,
        controllerAs: 'vm',
        inputs: {
          clientEmail: clientEmail,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function SendCreditNoteToClientCtrl($element, clientEmail, successCallback) {
      let vm = this;

      vm.clientEmail = clientEmail;

      vm.sendCreditNote = function (isFormValid) {
        if (!isFormValid) return;

        vm.sendingForm = true;

        $element.modal('hide');
        successCallback(vm.clientEmail);
      };
    }
  }
})();
